import { Injectable, OnInit } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { LocalStorageService } from "angular-2-local-storage";
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MyMissingTranslationHandler implements MissingTranslationHandler {

    addKeys: string[] = []
    data: any = {};
    country: any;
    language: any;
    newKey: any;
    key:any;
    keyparams:any;
    sitemapId:any;
    private _url = "add key method in cms Url";

    constructor(private _http: HttpClient,
        private _localStorage: LocalStorageService) {
        this.country = this._localStorage.get("countryName")
        this.language = this._localStorage.get("language");
    }

    ngOnInit() {
    }

    /**
     * To handle missing key and return the same key as a value
     * @param  {MissingTranslationHandlerParams} params
     */
    handle(params: MissingTranslationHandlerParams) {
        if (this.language != null && this.language != undefined &&
             this.country != null && this.country != undefined ) {
             this.keyparams = params;
             if(this.keyparams != null && this.keyparams !=undefined){
                    this.key = this.keyparams.key.split('.')[1];
                    this.sitemapId = this.keyparams.key.split('.')[0];
             }
            this.data = {
                Key:  this.key,
                Value:  this.key,
                SitemapId:  this.sitemapId,
                Language: this.language,
                Country: this.country
            }
            this.newKey = this.addKeys.find((x: any) => x.Key ==  this.key);
            if(this.newKey == undefined || this.newKey == "" || this.newKey == null){
                  this.addKeys.push(this.data);
            }
            //this.addMissingKeyToCMS(this.addKeys, this.language, this.country);
        }
        return  this.key;
    }

    /**
     * To take a missing keys from the handler and add into cms server
     * @param  {string[]} keyValuePairs
     * @returns Observable
     */
    addMissingKeyToCMS(keyValuePair: string[]): Observable<any[]> {
        let data: any = { keyValuePairs: keyValuePair };
        let body = JSON.stringify(data);
        return this._http
            .post<any[]>(this._url, body)
            .catch(this.handleErrorObservable);

    }

    /**
    * To handle the obervable error response
    * @param  {Response|any} error
    */
    private handleErrorObservable(error: Response | any) {

        return Observable.throw(error.message || error);
    }
}